import axios from "axios";
import config from "../../constants/config";

const url1 = config.API_URL + '/promo/promotionalOffers';
const url3 = config.API_URL + '/promo/promoOffers';
const url4 = config.API_URL + '/promo/promoCode';
const url5 = config.API_URL + '/promo/editPromoOffer';

// const url7 = config.API_URL + '/promo/rabbetDailyPromoOffers';
// const url71 = config.API_URL + '/promo/rabbetDailyPromotionalOffers';


export const getKaratPromoOffer = async (token, limit, filter, isAdmin) => {
    console.log('called getKaratPromoOffer Method');
    return await axios.get(isAdmin ? url3 : url1, {
      params: {
        limit: limit,
        status: filter
      },
      headers: {
        Authorization: token, // Correct placement of Authorization header
        'Content-Type': 'application/json', // Ensure content type is set to JSON
      },
    });
  };


  export const updateKaratPromoOffer = async (token, promoID, promoData) => {
console.log('called updateKaratPromoOffer Method', token, promoID, promoData);
    return await axios.put(url5,promoData, {
        params: {
            promoId: promoID, // Query parameter
          },
      headers: {
        Authorization: token, // Correct placement of Authorization header
        'Content-Type': 'application/json', // Ensure content type is set to JSON
      },
    });
  };

  export const getPromoCode = async (token, promoID) => {
    console.log('called getPromoCode Method');
    return await axios.get(url4, {
      params: {
        promoOfferID: promoID, // Query parameter
      },
      headers: {
        Authorization: token, // Correct placement of Authorization header
        'Content-Type': 'application/json', // Ensure content type is set to JSON
      },
    });
  };